import { render, staticRenderFns } from "./VerificationPage.vue?vue&type=template&id=812f974a&scoped=true"
import script from "./VerificationPage.vue?vue&type=script&lang=js"
export * from "./VerificationPage.vue?vue&type=script&lang=js"
import style0 from "./VerificationPage.vue?vue&type=style&index=0&id=812f974a&prod&lang=css"
import style1 from "./VerificationPage.vue?vue&type=style&index=1&id=812f974a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812f974a",
  null
  
)

export default component.exports